import React from 'react';
import Modes from "../../exercises/mode/Modes";
import NumberSystems from "../../exercises/NumberSystems";
import CalculationTypes from "../../exercises/CalculationTypes";
import Constants from "../constants";

class ModeItemExercise extends React.Component{
    formatTaskForDisplay = (value) => {
        const mode = this.props.mode;
        if(
            mode.getCalculationType() === CalculationTypes.ADDITION || mode.getCalculationType() === CalculationTypes.SUBTRACTION ||
            mode.equals(Modes.DECIMAL_TO_BINARY_EXCESS_127_8_BIT) ||
            mode.equals(Modes.DECIMAL_TO_BINARY_EXCESS_127_8_BIT)){
            //Excess 127 has an actual standrring as a mode
            return value;
        }

        switch(mode.getNumberSystems()[0]){
            case NumberSystems.BINARY:
                return this.formatBinaryValue(value);
            case NumberSystems.HEXADECIMAL:
                return value.toUpperCase();
            case NumberSystems.OCTAL:
            case NumberSystems.DECIMAL:
            default:
                return value;
        }
    };

    formatBinaryValue = (value) => {
        let appendMinus = false;
        if(value.indexOf(Constants.MINUS)>-1){
            appendMinus = true;
            value = value.substring(1, value.length);
        }
        const binaryStringCharacterArray = value.split("");
        let paddedBinaryStringBuilder = "";

        let paddingCounter = 0;
        for (let i = binaryStringCharacterArray.length-1; i>=0; i--) {
            const c = binaryStringCharacterArray[i];

            paddedBinaryStringBuilder = paddedBinaryStringBuilder + c;

            if(c === Constants.COMMA){
                paddingCounter = 0;
                continue;
            }

            paddingCounter++;
            if (paddingCounter < 4) {
                continue;
            }

            paddingCounter = 0;

            if(i>0){
                const nextChar = binaryStringCharacterArray[i-1];
                if(nextChar === Constants.COMMA){
                    continue;
                }
            }
            paddedBinaryStringBuilder = paddedBinaryStringBuilder + " ";
        }

        let formattedString = this.reverseString(paddedBinaryStringBuilder);
        if(appendMinus){
           formattedString = `${Constants.MINUS}${formattedString}`;
        }
        return formattedString;
    };

    reverseString = (string) => {
        return string.split("").reverse().join("");
    };

    render(){
        const task = this.props.mode.getExercise().getTask();
        let taskForDisplay = this.formatTaskForDisplay(task[0]);
        if(task.length > 1){
            if(this.props.mode.equals(Modes.BINARY_ADDITION)){
                taskForDisplay = taskForDisplay + " + " + task[1];
            }else if(this.props.mode.equals(Modes.BINARY_SUBTRACTION)){
                taskForDisplay = taskForDisplay + " - " + task[1];
            }
        }
        return(
            <div className={"mode-card-exercise-col mode-card-exercise"}>
                {taskForDisplay}
            </div>
        );
    }
}
export default ModeItemExercise